import React from 'react';

const IconYoutube = () => {
  return (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_175_657)">
          <path
            d="M40.095 11.4737C40.095 11.4737 39.7049 8.5325 38.5057 7.2375C36.984 5.54 35.2797 5.53 34.4982 5.43375C28.9002 5 20.5039 5 20.5039 5C15.8361 5 11.1469 5.07299 6.49199 5.43375C5.7105 5.53 4.00746 5.54 2.48449 7.2375C1.28661 8.5325 0.895242 11.4737 0.895242 11.4737C0.895242 11.4737 0.495117 14.925 0.495117 18.3762V21.6112C0.495117 25.065 0.895242 28.515 0.895242 28.515C0.895242 28.515 1.28536 31.455 2.48449 32.7475C4.00746 34.445 6.00434 34.3937 6.89462 34.5712C10.0944 34.8987 20.4951 35 20.4951 35C20.4951 35 28.9002 34.985 34.4982 34.5562C35.2797 34.4562 36.984 34.4462 38.5057 32.7487C39.7036 31.4562 40.095 28.5162 40.095 28.5162C40.095 28.5162 40.4951 25.065 40.4951 21.6125V18.3775C40.4951 14.925 40.095 11.4737 40.095 11.4737Z"
            fill="black"
          />
          <path d="M15.5 12.5V27.5L28.0039 20L15.5 12.5Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_175_657">
            <rect
              width="40"
              height="40"
              fill="white"
              transform="translate(0.495117)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default IconYoutube;
